import React, { useEffect, useState } from 'react';
import { Card } from '../components/micro/Card/Card';
import { usePortContext } from '../service/MessageChannelContext';
import { Navbar } from '../components/micro/NavBar/NavBar';
import SkinDiaryImage from '../images/skin-diary.png';
import NoReportHistoryImage from '../images/no-report-history.png';
import NoPhotoHistoryImage from '../images/no-photo-history.png';
import './MySkinDiary.scss';
import { Button } from '../components/micro/Button/Button';
import { useNavigate } from 'react-router-dom';
import { ReportList } from '../components/micro/ReportList/ReportList';
import { ReportPhotoList } from '../components/micro/ReportPhotoList/ReportPhotoList';
import { InsightCarousel } from '../components/micro/InsightCarousel/InsightCarousel';

const content = {
  skinReportHistoryTitle: {
    en: 'Skin Report History',
    id: 'Skin Report History',
  },
  photoHistoryTitle: {
    en: 'Photo History',
    id: 'Photo History',
  },
  skinAnalysisPrompt: {
    en: 'Do AI Skin Analysis Now',
    id: 'Lakukan Analisis Kulit Sekarang',
  },
  viewAll: {
    en: 'View All',
    id: 'Lihat Semua',
  },
  comparePhotos: {
    en: 'Compare Photos',
    id: 'Bandingkan Foto',
  },
};

const SkinDiary = () => {
  const { historyData, lang } = usePortContext();
  const [reportHistory, setReportHistory] = useState([]);
  const [insights, setInsights] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (historyData) {
      setReportHistory(historyData?.analyses);
      setInsights(historyData?.insights);
    }
  }, [historyData]);

  return (
    <div className="skin-diary">
      <Navbar leftButtonIcon={null} logo={SkinDiaryImage} />
      <Card title={content.skinReportHistoryTitle[lang]}>
        {reportHistory.length === 0 ? (
          <>
            <img src={NoReportHistoryImage} alt="NoReportHistory" className="placeholder-image" />
            <Button text={content.skinAnalysisPrompt[lang]} onClick={() => navigate('/howTo')} />
          </>
        ) : (
          <>
            <ReportList
              reports={reportHistory.slice(0, 3)}
              onClick={(analysisId) => {
                navigate(`/skinReport`, { state: reportHistory.find((report) => report.analysisId === analysisId) });
              }}
            />
            <Button
              text={content.viewAll[lang] + ` (${reportHistory.length})`}
              onClick={() => navigate('/reportHistory')}
              variant={'tertiary'}
            />
          </>
        )}
      </Card>
      <Card title={content.photoHistoryTitle[lang]}>
        {reportHistory.length === 0 ? (
          <>
            <img src={NoPhotoHistoryImage} alt="NoPhotoHistory" />
            <Button text={content.skinAnalysisPrompt[lang]} onClick={() => navigate('/howTo')} />
          </>
        ) : (
          <>
            <ReportPhotoList
              reports={reportHistory.slice(0, 3)}
              showDate
              onClick={(analysisId) => navigate('/photoHistory', { state: { analysisId } })}
            />
            <Button text={content.comparePhotos[lang]} onClick={() => navigate('/photoHistory')} variant={'tertiary'} />
          </>
        )}
      </Card>
      <div className="insights">
        <div className="insights-title">Personalised Insights</div>
        <InsightCarousel insights={insights} onClick={(insight) => navigate('/detailBlog', { state: insight })} />
      </div>
    </div>
  );
};

export default SkinDiary;
